import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

const IQACMOM = () => {
  const topRef = useRef(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  
  // Updated list with IQAC MOM specific data
 const pdfList = [
  { 
    id: 4, 
    title: "IQAC MOM (11/07/2026)", 
    src: "/pdf/iqac/IQAC MoM.pdf", 
    isWeb: false 
  },
  { 
    id: 3, 
    title: "IQAC MOM (A.Y. 2022-23 to A.Y. 2024-25)", 
    src: "/pdf/iqac/IQAC-MOM2022-2025.pdf", // Ensure these paths match your folder structure
    isWeb: false 
  },
  { 
    id: 1, 
    title: "IQAC MOM (A.Y. 2019-20 to A.Y. 2021-22)", 
    src: "/pdf/iqac/IQAC-MOM.pdf", 
    isWeb: false 
  },
];
  const [activePdf, setActivePdf] = useState(pdfList[0]);

  const handlePdfSelection = (pdf) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    window.scrollTo({ top: 0, behavior: "smooth" });

    if (pdf.isWeb) {
      window.open(pdf.src, "_blank");
    } else {
      setActivePdf(pdf);
    }

    setMobileOpen(false); // close drawer on mobile
  };

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="spv-modern-portal">
        <div ref={topRef}>
          <PageHeader 
            title="IQAC Minutes of Meeting" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'IQAC MOM' }]} 
          />
        </div>

        <div className="spv-main-content">
          <>
            <div 
              className={`spv-mobile-overlay ${mobileOpen ? "active" : ""}`}
              onClick={() => setMobileOpen(false)}
            />

            <aside className={`spv-sidebar-modern ${mobileOpen ? "mobile-open" : ""}`}>
              <div className="spv-sidebar-header-text">MEETING RECORDS</div>
              <nav className="spv-nav-group">
                {pdfList.map((pdf) => (
                  <button
                    key={pdf.id}
                    className={`spv-nav-card ${activePdf.id === pdf.id ? "is-active" : ""}`}
                    onClick={() => handlePdfSelection(pdf)}
                  >
                    <div className="spv-card-content">
                      <img 
                        src={pdf.isWeb ? "/images/icons/browser.svg" : "/images/icons/pdf.svg"} 
                        alt="icon" 
                        className="spv-doc-icon-img" 
                      />
                      <span className="spv-card-text">{pdf.title}</span>
                      <img 
                        src="/images/icons/move.webp" 
                        alt="arrow icon" 
                        className="spv-doc-icon-img" 
                      />
                    </div>
                  </button>
                ))}
              </nav>
            </aside>
          </>

<main className="spv-viewer-area" key={activePdf.id}>            <header className="spv-viewer-topbar">
              <div style={{ display: "flex", alignItems: "center" }}>
                <h2 className="spv-doc-title">{activePdf.title}</h2>
              </div>

              <div className="spv-action-group">
                <button 
                  className="spv-btn spv-btn-outline" 
                  onClick={() => window.open(activePdf.src)}
                >
                  Full Screen
                </button>
              </div>
            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                <iframe
                  src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                  className="spv-iframe-content secure-frame"
                  title="IQAC MOM Document"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default IQACMOM;